import { useCallback, useState } from 'react'

import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { RECOMMENDED_SECTION_IDS } from '@src/quince-site-pdp/src/contexts/productPageContext.constants'

import {
  NEW_RECOMMENDED_SECTION_LIMIT_UI,
  NEW_RECOMMENDED_SECTION_LIMIT_UI_MOBILE,
  RECOMMENDED_SECTION_PRIORITY_ARRAY,
  transformedRecommendationData,
} from '../contexts/product.helpers'
import {
  productContextInitialState,
  RecommendationModuleData,
  RecommendationUIData,
} from '../contexts/ProductPageContext'

const useRecommendation = (productPageExpData: any) => {
  const [recommendationQuinceAPIData, setQuinceRecommendationAPIData] = useState<RecommendationUIData>(
    productContextInitialState.recommendationUIData,
  )
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  //Quince recommendation flow
  const updateRecommendationAPIData = useCallback(
    (sectionKey: RECOMMENDED_SECTION_IDS, sectionValue: RecommendationModuleData) => {
      setQuinceRecommendationAPIData(prevData => ({ ...prevData, [sectionKey]: sectionValue }))
    },
    [],
  )
  const defaultRecommendedSectionLimitForNewPDP = isDesktop
    ? NEW_RECOMMENDED_SECTION_LIMIT_UI
    : NEW_RECOMMENDED_SECTION_LIMIT_UI_MOBILE

  const transformedUIData = transformedRecommendationData(
    recommendationQuinceAPIData,
    productPageExpData?.recommendedSectionPriorityArray ?? RECOMMENDED_SECTION_PRIORITY_ARRAY,
    productPageExpData?.recommendationSectionLimit ?? defaultRecommendedSectionLimitForNewPDP,
  )

  return {
    recommendationUIData: transformedUIData,
    updateRecommendationAPIData,
    isRecommendationLoading: false,
  }
}

export default useRecommendation
